import axios from "./api";

const LitsenziyaService = {

    async getLitsenziyaList() {
        try {
            const response = await axios.get('/litsenziya');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async getLitsenziyaListByFilter(pageNumber, perPage, search, orderBy, days, transportId, last) {
        try {
            const response = await axios.get('/litsenziya', {
                params: {
                    per_page: perPage,
                    page: pageNumber,
                    search: search,
                    order_by: orderBy,
                    days: days,
                    transport_id: transportId,
                    last: last
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async addLitsenziya(formData) {
        try {
            const response = await axios.post('/litsenziya', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async updateLitsenziya(formData, id) {
        try {
            console.log('updatega keldi')
            const response = await axios.post('/litsenziya/' + id + '?_method=PUT', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating litsenziya';
        }
    },
    async deleteLitsenziya(id) {
        try {
            const response = await axios.delete('/litsenziya/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error deleting litsenziya';
        }
    }
}

export default LitsenziyaService;